export const EMAIL_AI_TONE_OPTIONS = [
  'Formal',
  'Casual',
  'Friendly',
  'Persuasive',
  'Dan',
  'Gary',
  'Alex',
];

export const EMAIL_AI_PROMPT_PLACEHOLDER =
  "e.g. Send a friendly appointment reminder for tomorrow's consultation, a promotional offer for our spring sale, or a personalized follow-up for customers who attended last week's webinar";

export const EMAIL_AI_HELPER_TEXT =
  'Be specific about details like purpose, audience, and desired outcome to get the best results';

export const EMAIL_AI_ERROR_MESSAGE =
  'AI could not generate the email. Please try again.';

export function collectAutomationVariables(variableCategories = []) {
  return variableCategories.flatMap((category) =>
    (category.variables || []).map((variable) => variable.token)
  );
}

export function canGenerateEmail(prompt) {
  return Boolean((prompt || '').trim());
}

export function canUseGeneratedEmail(generatedEmail) {
  return Boolean((generatedEmail || '').trim());
}

export function formatEmailForEditor(email, asPlainText) {
  if (!email) return '';
  if (!asPlainText) return email;

  return email
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<\/li>/gi, '\n')
    .replace(/<li[^>]*>/gi, '• ')
    .replace(/<[^>]+>/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function buildWriteEmailPayload({
  tone,
  prompt,
  workflowId,
  stepId,
  existingEmail,
  availableVariables,
}) {
  return {
    tone,
    prompt: (prompt || '').trim(),
    context: {
      workflow_id: workflowId || null,
      step_id: stepId || null,
      existing_email: existingEmail || '',
      available_variables: availableVariables || [],
    },
  };
}
